export enum SortTypes {
  Recommended = 'Recommended',
  RecommendedCustomerAgent = 'RecommendedCustomerAgent',
  MostBooked = 'MostBooked',
  BiggestSavings = 'BiggestSavings',
  BiggestSavingsPercentage = 'BiggestSavingsPercentage',
  GuestRating = 'GuestRating',
  BrandNames = 'BrandNames',
  PriceAsc = 'PriceAsc',
  PriceDesc = 'PriceDesc',
  DistanceAsc = 'DistanceAsc',
  DistanceDesc = 'DistanceDesc',
  Popularity = 'Popularity',
  Nearest = 'Nearest',
  MostPopular = 'MostPopular',
  /** Activity review score ordering (TRAV23 activities-front merge). */
  RatingAsc = 'RatingAsc',
  RatingDesc = 'RatingDesc',
  ClosestDateRange = 'ClosestDateRange',
  FarthestDateRange = 'FarthestDateRange',
  SavedProperties = 'SavedProperties'
}
